export type ConfirmDeleteState = 'idle' | 'confirming' | 'deleting'

export type ConfirmDeleteEvent =
  | { type: 'ask' }
  | { type: 'cancel' }
  | { type: 'confirm' }
  | { type: 'done' }
  | { type: 'fail' }

export function confirmDeleteReduce(
  state: ConfirmDeleteState,
  event: ConfirmDeleteEvent,
): ConfirmDeleteState {
  if (event.type === 'ask' && state === 'idle') return 'confirming'
  if (event.type === 'cancel' && (state === 'confirming' || state === 'deleting')) return 'idle'
  if (event.type === 'confirm' && state === 'confirming') return 'deleting'
  if (event.type === 'done' && state === 'deleting') return 'idle'
  if (event.type === 'fail' && state === 'deleting') return 'confirming'
  return state
}

export function needsForecastEffect(amountCents: number | null | undefined): boolean {
  return Number.isFinite(Number(amountCents)) && Math.abs(Number(amountCents)) >= 100000
}
